import { css, cx } from '@onbeam/business-styled-system/css';
import { LinkProps } from './Link.types';
import { flex } from '@onbeam/business-styled-system/patterns';
import NextLink from 'next/link';
import { ArrowDiagonalIcon } from '@onbeam/icons/business';

export const Link = ({
  href,
  css: cssProp,
  iconSize = 18,
  isExternal,
  alwaysShowIcon,
  className,
  children,
}: LinkProps) => (
  <NextLink
    href={href}
    className={cx(
      'group',
      css(flex.raw({ gap: '0.5', textStyle: 'body-lg' }), cssProp),
      className,
    )}
    {...(isExternal && {
      target: '_blank',
      rel: 'noopener noreferrer',
    })}
  >
    <span
      className={flex({
        position: 'relative',
        align: 'center',
        truncate: true,

        _before: {
          content: '""',
          position: 'absolute',
          bottom: '[3px]',
          left: '0',
          w: '[0]',
          h: '[1px]',
          bgColor: '[currentColor]',
          transitionProperty: 'width',
          transitionDuration: '[250ms]',
          transitionTimingFunction: 'ease',
        },

        _supportsHover: {
          _groupHover: {
            _before: {
              w: 'full',
            },
          },
        },
        _groupFocusActive: {
          _before: {
            w: 'full',
          },
        },
      })}
    >
      {children}
    </span>
    {isExternal && (
      <ArrowDiagonalIcon
        height={iconSize}
        width={iconSize}
        className={css({
          opacity: 0,
          mt: '0.5',
          transform: 'translate(-2px, 2px)',
          transitionProperty: 'opacity, transform',
          transitionDuration: 'fast',
          transitionTimingFunction: 'ease-in-out',
          flexShrink: 0,

          _supportsHover: {
            _groupHover: {
              opacity: 1,
              transform: 'translate(0, 0)',
            },
          },
          _groupFocusActive: {
            opacity: 1,
            transform: 'translate(0, 0)',
          },
          '&[data-always-show="true"]': {
            opacity: 1,
            transform: 'translate(0, 0)',
          },
        })}
        data-always-show={alwaysShowIcon}
      />
    )}
  </NextLink>
);
